import React, { forwardRef } from "react";
import Form from "./Form";

const FormWithRef = forwardRef((props, ref) => <Form {...props} forwardedRef={ref} />);

export default FormWithRef;
